import { createSlice } from "@reduxjs/toolkit";

interface IFile {
  id: 1;
  type: "image";
  url: "image1.jpg";
  name: "Image 1";
}
interface IConfluence {
  tableActive?: string;
  selectedId?: string;
  cellId?: string;
  colorName?: string;
  tableNumberd?: boolean;
  editMode: boolean;
  tocDrawer: boolean;
  editlink: boolean;
  codeSnippet: boolean;
  target?: null;
  showSuggestions?: boolean;
  showProfile?: boolean;
  mentionUser?: {
    userid?: string;
    username?: string;
    useremail?: string;
    useravatar?: string;
  };
  profilePosition: {
    top: number;
    left: number;
  };
  openImageSetting: boolean;
  showCorousel: boolean;
  file: IFile[];
  columnWidth: number;
  selectedColId: string;
  nextColId: string;
  documentData: string;
}

const initialState: IConfluence = {
  tableActive: "",
  selectedId: "",
  cellId: "",
  colorName: "#FFFFFF",
  tableNumberd: false,
  editMode: true,
  tocDrawer: false,
  editlink: false,
  codeSnippet: false,
  target: null,
  showSuggestions: false,
  showProfile: false,
  mentionUser: {
    userid: "",
    username: "",
    useremail: "",
    useravatar: "",
  },
  profilePosition: {
    top: 0,
    left: 0,
  },
  openImageSetting: false,
  showCorousel: false,
  file: [],
  columnWidth: 100,
  selectedColId: "",
  nextColId: "",
  documentData: "",
};

const slice = createSlice({
  name: "Tootle Components",
  initialState,
  reducers: {
    setTableActive(state, action) {
      state.tableActive = action.payload;
    },
    setSelectedId(state, action) {
      state.selectedId = action.payload;
    },
    setCellId(state, action) {
      state.cellId = action.payload;
    },
    setColorName(state, action) {
      state.colorName = action.payload;
    },
    setTableNumberd(state, action) {
      state.tableNumberd = action.payload;
    },
    setEditMode(state, action) {
      state.editMode = action.payload;
    },
    setOpenDrawer(state, action) {
      state.tocDrawer = action.payload;
    },
    setEditLink(state, action) {
      state.editlink = action.payload;
    },
    setCodeSnippent(state, action) {
      state.codeSnippet = action.payload;
    },
    setTarget(state, action) {
      state.target = action.payload;
    },
    setShowSuggestions(state, action) {
      state.showSuggestions = action.payload;
    },
    setShowProfile(state, action) {
      state.showProfile = action.payload;
    },
    setMentionUser(state, action) {
      state.mentionUser = action.payload;
    },
    setProfilePosition(state, action) {
      state.profilePosition = action.payload;
    },
    setOpenImageSetting(state, action) {
      state.openImageSetting = action.payload;
    },
    setShowCorousel(state, action) {
      state.showCorousel = action.payload;
    },
    setFile(state, action) {
      state.file = action.payload;
    },
    setColumnWidth(state, action) {
      state.columnWidth = action.payload;
    },
    setSelectedColId(state, action) {
      state.selectedColId = action.payload;
    },
    setNextColId(state, action) {
      state.nextColId = action.payload;
    },
    setDocumentData(state, action) {
      state.documentData = action.payload;
    },
  },
});

export const reducer = slice.reducer;

export const { setSelectedColId, setNextColId } = slice.actions;

export const updateTableActiveValue = (data) => async (dispatch) => {
  dispatch(slice.actions.setTableActive(data));
};

export const updateColumnWidth = (data) => async (dispatch) => {
  dispatch(slice.actions.setColumnWidth(data));
};

export const updateSelectedId = (data) => async (dispatch) => {
  dispatch(slice.actions.setSelectedId(data));
};

export const updateCellId = (data) => async (dispatch) => {
  dispatch(slice.actions.setCellId(data));
};

export const updateColorName = (data) => async (dispatch) => {
  dispatch(slice.actions.setColorName(data));
};

export const updateTableNumbered = (data) => async (dispatch) => {
  dispatch(slice.actions.setTableNumberd(data));
};

export const updateEditMode = (data) => async (dispatch) => {
  dispatch(slice.actions.setEditMode(data));
};

export const openTableOfContent = (data) => async (dispatch) => {
  dispatch(slice.actions.setOpenDrawer(data));
};

export const updateEditLink = (data) => async (dispatch) => {
  dispatch(slice.actions.setEditLink(data));
};

export const updateCodeSnippent = (data) => async (dispatch) => {
  dispatch(slice.actions.setCodeSnippent(data));
};

export const updateTarget = (data) => async (dispatch) => {
  dispatch(slice.actions.setTarget(data));
};

export const updateShowSuggestions = (data) => async (dispatch) => {
  dispatch(slice.actions.setShowSuggestions(data));
};
export const updateShowProfile = (data) => async (dispatch) => {
  dispatch(slice.actions.setShowProfile(data));
};
export const updateMentionUser = (data) => async (dispatch) => {
  dispatch(slice.actions.setMentionUser(data));
};
export const updateProfilePosition = (data) => async (dispatch) => {
  dispatch(slice.actions.setProfilePosition(data));
};
export const updateOpenImageSetting = (data) => async (dispatch) => {
  dispatch(slice.actions.setOpenImageSetting(data));
};
export const updateShowCorousel = (data) => async (dispatch) => {
  dispatch(slice.actions.setShowCorousel(data));
};
export const updateFile = (data) => async (dispatch) => {
  dispatch(slice.actions.setFile(data));
};
export const updateDocumentData = (data) => async (dispatch) => {
  dispatch(slice.actions.setDocumentData(data));
};
export default slice.reducer;
